import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { client } from '../api/client'
import './FlagRankPage.css'
const labels=['密码','注释','控制台','网络','本地存储','Cookie','移动视图','源码']
export default function FlagRankPage({detail=false}) {
  const [rows,setRows]=useState([]),[classroom,setClassroom]=useState(null),[now,setNow]=useState(Date.now()),[error,setError]=useState('')
  useEffect(()=>{
    let alive=true
    const refresh=async()=>{
      try { const [c,r]=await Promise.all([client.get('/api/classroom'),client.get('/flags-all')]);if(alive){setClassroom(c.data);setRows(r.data);setError('')} }
      catch(e){if(alive)setError(String(e))}
    }
    refresh();const poll=setInterval(refresh,3000),clock=setInterval(()=>setNow(Date.now()),1000)
    return()=>{alive=false;clearInterval(poll);clearInterval(clock)}
  },[])
  const ranked=[...rows].sort((a,b)=>b.flags.reduce((x,y)=>x+y,0)-a.flags.reduce((x,y)=>x+y,0)||a.team-b.team)
  const left=classroom?.endsAt?Math.max(0,Math.ceil((Date.parse(classroom.endsAt)-now)/60000)):null
  return <div className="flag-rank-container">
    <div className="flag-rank-title-container"><h1>{classroom?.name} · “赌场探秘”{detail?'各关进度':'实时排行'}</h1>
      <p>{new Date(now).toLocaleString()} · {left===null?'未设置结束时间':left===0?'本次课堂计时已结束':`剩余${Math.floor(left/60)}小时${left%60}分钟`}</p>
      <Link to="/">返回课堂</Link> · <Link to={detail?'/flag-rank':'/flag-rank'}>{detail?'总分排行':'各关进度'}</Link>
      <p role="status">{error}</p>
    </div>
    <div className="flag-rank-content-container">{ranked.map((row,i)=><div className="flag-rank-team-card-container" key={row.team}>
      <div className="flag-rank-team-card-text-container"><span className="flag-rank-team-card-text">{row.team}号战队</span><span>{row.dorm}</span><span>第{i+1}名 · {row.flags.reduce((x,y)=>x+y,0)}/8</span></div>
      <div className="flag-rank-team-card-signs-container">{row.flags.map((done,j)=><span key={j} title={labels[j]} style={{margin:5,textAlign:'center'}}>{done?'🚩':'⚐'}{detail&&<small style={{display:'block'}}>{labels[j]}</small>}</span>)}</div>
    </div>)}</div>
  </div>
}
